export class GetMeetingDetailsTimedoutError extends Error {
  public name = 'GetMeetingDetailsTimedoutError';

  constructor(...args: Parameters<ErrorConstructor>) {
    super(...args);
    Object.setPrototypeOf(this, GetMeetingDetailsTimedoutError.prototype);
  }
}
